import React from "react";
import P from "./p";

export default function ErrorMessage({ error }) {
  return <P style={{ color: "red", fontWeight: "bold", marginBottom: "1rem" }}>{error.message}</P>;
}
